// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* :root {
  --primary-color: #1b5bff;
  --secondary-color: #a370ce;
  --secondary-dark-bg: #b17cdd;
  --text-color: #6b6b6b;
  --text2-color: #bdcbd4;
  --dark-color: #1e1e1e;
  --dark2-color: #4d4d4d;
  --body-bg-color: #f1f5ff;
  --icon-bg-color: #eeebff;
  --icon2-bg-color: #dae4fe;
  --white-color: #fff;
  --gradient-color-start: rgb(163, 112, 206);
  --gradient-color-end: rgba(16, 55, 153, 80%);
  --border-gradient-color: rgba(163, 112, 206, 100%);
  --border-gradient-color2: rgba(163, 112, 206, 50%);
  --next-border-gradient-color: rgba(16, 55, 153, 17%);
  --primary-gradient: linear-gradient(
    45deg,
    rgb(173, 117, 220),
    rgba(70, 101, 178, 80%)
  );
  --saveBtn: #28a745;
  --saveHover: #1b8f36;
  --deleteBtn: #ff485b;
  --deleteHover: #c82333;
  --editBtn: #3797fe;
  --editHover: #0056b3;
  --warning: #ff9800;
  --white-color: linear-gradient(135deg, #ffffff 0%, #fff9f0 100%);
  --cardBox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  --cardBox-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.12);
} */

:root {
  /* ==========================
     Brand Colors
  ========================== */
  --primary: #3797fe;
  --primary-light: #6db6ff;
  --primary-dark: #1d7eea;
  --primary-hover: #2f88e8;

  /* ==========================
     Backgrounds
  ========================== */
  --bg-primary: #ffffff;
  --bg-secondary: #efefef;
  --bg-surface: #e8e3ff;
  --bg-icon: #eceeee;

  /* ==========================
     Text Colors
  ========================== */
  --heading: #515355;
  --subheading: #79787b;
  --text-light: #a0a0a3;
  --dark-color: #1e1e1e;

  /* ==========================
     save / update buttons
  ========================== */
  --saveBtn: #37a57f;
  --saveHover: #2b8465;
  --white-color: #fff;
  --cancelBtn: #e2e2e2;
  --deleteBtn: #ff485b;
  --deleteHover: #c82333;
  --editBtn: #3797fe;
  --editHover: #0056b3;
  --warning: #ff9800;

  /* ==========================
     Status Colors
  ========================== */
  --success: #5ab394;
  --success-light: #7ed1b5;

  --danger: #c57975;
  --danger-light: #e2a29e;

  /* ==========================
     Borders
  ========================== */
  --border: #e2e2e2;
  --border-light: #f3f3f3;

  /* ==========================
     Shadows
  ========================== */
  --shadow-sm: 0 2px 8px rgba(55, 151, 254, 0.08);
  --shadow-md: 0 8px 24px rgba(55, 151, 254, 0.12);
  --shadow-lg: 0 16px 40px rgba(55, 151, 254, 0.16);

  /* ==========================
     Gradients
  ========================== */

  /* Primary Button */
  --gradient-primary: linear-gradient(135deg, #3797fe 0%, #70bbff 100%);

  /* Hero Section */
  --gradient-hero: linear-gradient(135deg, #3797fe 0%, #7b61ff 100%);

  /* Soft Card */
  --gradient-card: linear-gradient(135deg, #ffffff 0%, #e8e3ff 100%);

  /* Background */
  --gradient-bg: linear-gradient(180deg, #ffffff 0%, #e8e3ff 100%);

  /* Success */
  --gradient-success: linear-gradient(135deg, #5ab394 0%, #7ed1b5 100%);

  /* Danger */
  --gradient-danger: linear-gradient(135deg, #c57975 0%, #e2a29e 100%);

  /* Premium Blue Glow */
  --gradient-glow: radial-gradient(
    circle at top right,
    rgba(55, 151, 254, 0.2),
    transparent 70%
  );

  /* Glass Effect */
  --gradient-glass: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.8),
    rgba(245, 233, 255, 0.6)
  );
}

body {
  background: var(--bg-secondary);
}
.appWrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* overflow: hidden; */
}
.render_header {
  /* position: fixed;
  top: 0;
  left: 0;
  right: 0; */
  background: white;
  z-index: 1000;
  height: 6vh;
  width: 100%;
}

.render_body {
  /* margin-top: 6vh; */
  flex: 1 1;
  height: 100%;
  /* overflow-y: hidden; */
  position: relative;
  z-index: 1;
  height: 94vh;
}
.actionBtns {
  position: fixed;
  left: 0;
  right: 0;
  padding: 0 85px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* height: 100px; */
  bottom: 0px;
  z-index: 1;
  margin: 0px auto;
  max-width: 1250px;
}
@media screen and (max-width: 368px) {
  .actionBtns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
  }
}

@media screen and (min-width: 1068px) and (max-width: 1568px) {
  .actionBtns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    max-width: 800px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1067px) {
  .actionBtns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    max-width: 700px;
  }
  .render_body {
    /* margin-top: 60px; */
    flex: 1 1;
    overflow-y: hidden;
    position: relative;
    z-index: 1;
    /* background-color: #fafafa; */
    /* padding: 20px; */
    box-sizing: border-box;
    padding-left: 0px;
    overflow: auto;
    padding-bottom: 0px;
  }
}
@media screen and (max-width: 480px) {
  .actionBtns {
    /* display: flex; */
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
  }
  .actionBtns .buttons {
    font-size: 16px;
    padding: 0px 20px;
  }
  .render_body {
    overflow-y: auto;
    margin-bottom: 50px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .render_body::-webkit-scrollbar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;;AAEH;EACE;;8BAE4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB;;8BAE4B;EAC5B,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;;EAElB;;8BAE4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB;;8BAE4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;;EAElB;;8BAE4B;EAC5B,kBAAkB;EAClB,wBAAwB;;EAExB,iBAAiB;EACjB,uBAAuB;;EAEvB;;8BAE4B;EAC5B,iBAAiB;EACjB,uBAAuB;;EAEvB;;8BAE4B;EAC5B,+CAA+C;EAC/C,gDAAgD;EAChD,iDAAiD;;EAEjD;;8BAE4B;;EAE5B,mBAAmB;EACnB,qEAAqE;;EAErE,iBAAiB;EACjB,kEAAkE;;EAElE,cAAc;EACd,kEAAkE;;EAElE,eAAe;EACf,gEAAgE;;EAEhE,YAAY;EACZ,qEAAqE;;EAErE,WAAW;EACX,oEAAoE;;EAEpE,sBAAsB;EACtB;;;;GAIC;;EAED,iBAAiB;EACjB;;;;GAIC;AACH;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;;;aAGW;EACX,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,SAAO;EACP,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,SAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n/* :root {\n  --primary-color: #1b5bff;\n  --secondary-color: #a370ce;\n  --secondary-dark-bg: #b17cdd;\n  --text-color: #6b6b6b;\n  --text2-color: #bdcbd4;\n  --dark-color: #1e1e1e;\n  --dark2-color: #4d4d4d;\n  --body-bg-color: #f1f5ff;\n  --icon-bg-color: #eeebff;\n  --icon2-bg-color: #dae4fe;\n  --white-color: #fff;\n  --gradient-color-start: rgb(163, 112, 206);\n  --gradient-color-end: rgba(16, 55, 153, 80%);\n  --border-gradient-color: rgba(163, 112, 206, 100%);\n  --border-gradient-color2: rgba(163, 112, 206, 50%);\n  --next-border-gradient-color: rgba(16, 55, 153, 17%);\n  --primary-gradient: linear-gradient(\n    45deg,\n    rgb(173, 117, 220),\n    rgba(70, 101, 178, 80%)\n  );\n  --saveBtn: #28a745;\n  --saveHover: #1b8f36;\n  --deleteBtn: #ff485b;\n  --deleteHover: #c82333;\n  --editBtn: #3797fe;\n  --editHover: #0056b3;\n  --warning: #ff9800;\n  --white-color: linear-gradient(135deg, #ffffff 0%, #fff9f0 100%);\n  --cardBox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --cardBox-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.12);\n} */\n\n:root {\n  /* ==========================\n     Brand Colors\n  ========================== */\n  --primary: #3797fe;\n  --primary-light: #6db6ff;\n  --primary-dark: #1d7eea;\n  --primary-hover: #2f88e8;\n\n  /* ==========================\n     Backgrounds\n  ========================== */\n  --bg-primary: #ffffff;\n  --bg-secondary: #efefef;\n  --bg-surface: #e8e3ff;\n  --bg-icon: #eceeee;\n\n  /* ==========================\n     Text Colors\n  ========================== */\n  --heading: #515355;\n  --subheading: #79787b;\n  --text-light: #a0a0a3;\n  --dark-color: #1e1e1e;\n\n  /* ==========================\n     save / update buttons\n  ========================== */\n  --saveBtn: #37a57f;\n  --saveHover: #2b8465;\n  --white-color: #fff;\n  --cancelBtn: #e2e2e2;\n  --deleteBtn: #ff485b;\n  --deleteHover: #c82333;\n  --editBtn: #3797fe;\n  --editHover: #0056b3;\n  --warning: #ff9800;\n\n  /* ==========================\n     Status Colors\n  ========================== */\n  --success: #5ab394;\n  --success-light: #7ed1b5;\n\n  --danger: #c57975;\n  --danger-light: #e2a29e;\n\n  /* ==========================\n     Borders\n  ========================== */\n  --border: #e2e2e2;\n  --border-light: #f3f3f3;\n\n  /* ==========================\n     Shadows\n  ========================== */\n  --shadow-sm: 0 2px 8px rgba(55, 151, 254, 0.08);\n  --shadow-md: 0 8px 24px rgba(55, 151, 254, 0.12);\n  --shadow-lg: 0 16px 40px rgba(55, 151, 254, 0.16);\n\n  /* ==========================\n     Gradients\n  ========================== */\n\n  /* Primary Button */\n  --gradient-primary: linear-gradient(135deg, #3797fe 0%, #70bbff 100%);\n\n  /* Hero Section */\n  --gradient-hero: linear-gradient(135deg, #3797fe 0%, #7b61ff 100%);\n\n  /* Soft Card */\n  --gradient-card: linear-gradient(135deg, #ffffff 0%, #e8e3ff 100%);\n\n  /* Background */\n  --gradient-bg: linear-gradient(180deg, #ffffff 0%, #e8e3ff 100%);\n\n  /* Success */\n  --gradient-success: linear-gradient(135deg, #5ab394 0%, #7ed1b5 100%);\n\n  /* Danger */\n  --gradient-danger: linear-gradient(135deg, #c57975 0%, #e2a29e 100%);\n\n  /* Premium Blue Glow */\n  --gradient-glow: radial-gradient(\n    circle at top right,\n    rgba(55, 151, 254, 0.2),\n    transparent 70%\n  );\n\n  /* Glass Effect */\n  --gradient-glass: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.8),\n    rgba(245, 233, 255, 0.6)\n  );\n}\n\nbody {\n  background: var(--bg-secondary);\n}\n.appWrap {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  /* overflow: hidden; */\n}\n.render_header {\n  /* position: fixed;\n  top: 0;\n  left: 0;\n  right: 0; */\n  background: white;\n  z-index: 1000;\n  height: 6vh;\n  width: 100%;\n}\n\n.render_body {\n  /* margin-top: 6vh; */\n  flex: 1;\n  height: 100%;\n  /* overflow-y: hidden; */\n  position: relative;\n  z-index: 1;\n  height: 94vh;\n}\n.actionBtns {\n  position: fixed;\n  left: 0;\n  right: 0;\n  padding: 0 85px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* height: 100px; */\n  bottom: 0px;\n  z-index: 1;\n  margin: 0px auto;\n  max-width: 1250px;\n}\n@media screen and (max-width: 368px) {\n  .actionBtns {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 10px;\n  }\n}\n\n@media screen and (min-width: 1068px) and (max-width: 1568px) {\n  .actionBtns {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 10px;\n    max-width: 800px;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1067px) {\n  .actionBtns {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 10px;\n    max-width: 700px;\n  }\n  .render_body {\n    /* margin-top: 60px; */\n    flex: 1;\n    overflow-y: hidden;\n    position: relative;\n    z-index: 1;\n    /* background-color: #fafafa; */\n    /* padding: 20px; */\n    box-sizing: border-box;\n    padding-left: 0px;\n    overflow: auto;\n    padding-bottom: 0px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .actionBtns {\n    /* display: flex; */\n    display: none;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 10px;\n  }\n  .actionBtns .buttons {\n    font-size: 16px;\n    padding: 0px 20px;\n  }\n  .render_body {\n    overflow-y: auto;\n    margin-bottom: 50px;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  .render_body::-webkit-scrollbar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
